var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-box"},[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"#4A148C"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }